import { trigger, transition, style, animate } from '@angular/animations';
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output, Input, Injectable, ViewChild } from '@angular/core';
import { delay } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import {  DataConnectorTypeIngest } from '../../../domainObjects/dataConnector';
import {  ConfigService, DataConnectorOptionItemIngest } from '../../../services/config/config.service';
import { ErrorReportingService } from '../../../services/errorReporting/error-reporting.service';
import { DataConnectorMapping } from '../../../domainObjects/dataConnectorMapping';
import { DataTransform } from '../../../domainObjects/dataTransform';
import { DataTransformConfigViewModel } from '../../../viewModels/dataTransformConfigViewModel';
import { UserDataService } from 'src/app/services/user-data-service';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { OptionItem } from 'src/app/model/optionItem';
import { IngestConfigViewModel } from '../../import-data/import-data.component';
import { DataDictionaryItem, DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { BaseComponent } from 'src/app/base/base.component';
import { StepModel } from '../../dataTransformConfig/ingest/ingest-work-flow-layout/ingest-work-flow-layout.component';



export class IngestTransformConfigViewModel {
  guid: string;
  id: number;
  name: string;
  dataConnectorTypeIngest?: DataConnectorTypeIngest;

  constructor(dataConnectorMapping: DataConnectorMapping, columns: string[],  
    transforms: DataTransform<any>[], dataTransformConfig?: DataTransformerConfig  ) {
    this.guid = dataConnectorMapping.guid;
    this.id = dataConnectorMapping.id;
    this.name = dataConnectorMapping.name;
 
  }

}


@Component({
    selector: 'app-import-data-ingest',
    templateUrl: './import-data-ingest.component.html',
    styleUrls: ['./import-data-ingest.component.css'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0, }),
                animate(1000, style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate(1000, style({ opacity: 0 }))
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ImportDataIngestComponent extends BaseComponent implements OnInit {
  @Output() stateChanged = new EventEmitter<DataTransformConfigViewModel>();
  @Input() stepModel: StepModel;
  @Input() viewModel: DataTransformConfigViewModel;
  @Input() ingestTransformConfigViewModel: IngestTransformConfigViewModel;
  @Input() ingestConfig: IngestConfigViewModel;

  targetColumns: OptionItem[] = [];
  dataDictionaryItems: DataDictionaryItem[];
  // viewModel = new ImportDataSetupViewModel();
  // isMultiTabIngest = false;
  connectorType=""

  selectedDataConnectorType?: DataConnectorOptionItemIngest = null;
  dataConnectorTypeIngest = DataConnectorTypeIngest;


  dataConnectorsIngest: DataConnectorOptionItemIngest[] = [
    new DataConnectorOptionItemIngest(DataConnectorTypeIngest.DataTypeConverter, 'Data Type Converter', 'Import from a text or csv file', 'text_snippet'),
    new DataConnectorOptionItemIngest(DataConnectorTypeIngest.DurationCalc, 'Duration Calcs', 'Import from an excel file', 'text_snippet'),
    new DataConnectorOptionItemIngest(DataConnectorTypeIngest.DeduplicateRows, 'Deduplicate Rows', 'Import from a Database', 'table_rows'),
    new DataConnectorOptionItemIngest(DataConnectorTypeIngest.GeneralParameters, 'General Parameters', 'Import from Rest API', 'cloud_download'),
 
  ];

  routerLinkBase = '../mapper/';
  routerLink = '';
  aboutlink:string="";
  savedIngestConfig:any;
  json: string;
  constructor(
    logger: ErrorReportingService,
    dialog: MatDialog,
    private mapperService: ConfigService,
    private userData: UserDataService,
    private dataDictService: DataDictionaryService) {
    super(logger, dialog);
  }
  async ngOnInit(): Promise<void> {
    if (!this.selectedDataConnectorType) {
      const defaultConnector = this.dataConnectorsIngest.find(connector => connector.dataConnectorTypeIngest === DataConnectorTypeIngest.DataTypeConverter);
      if (defaultConnector) {
        this.onDataConnectorSelected(defaultConnector);
      }
    }
  

  }

  ngOnChanges(changes: any): void {
    this.json="";
  }

  onDataConnectorSelected(connectorIngest: DataConnectorOptionItemIngest): void {
    console.log("Selected connector:", connectorIngest.title);
    this.connectorType = connectorIngest.title;
  
    // Deselect all connectors and select the chosen one
    this.dataConnectorsIngest.forEach(option => option.isSelected = false);
    connectorIngest.isSelected = true;
  
    // Update view models
    this.selectedDataConnectorType = connectorIngest;
    this.viewModel.dataConnectorTypeIngest = connectorIngest.dataConnectorTypeIngest;
    this.ingestTransformConfigViewModel.dataConnectorTypeIngest = connectorIngest.dataConnectorTypeIngest;
  
    // Mark the step as complete and emit the change event
    this.viewModel.isDataValid = true;
    this.stepModel.isComplete = true;
    this.stateChanged.emit(this.viewModel);
    this.json="";
    // if(connectorIngest.title=="Duration Calcs"){
    //   var dataDictionaryItems = this.viewModel.dataTransformerConfig.dataConnectorMappings.find(x=>x.guid==this.viewModel.selectedIngestFarmGuid).columnMap;
    //   var timestamp=dataDictionaryItems.filter(x=>x.dataType=='Timestamp').length;
    //   var duration=dataDictionaryItems.filter(x=>x.dataType=='Duration').length;
    //   var durationcalcsValid=true;
    //   if(timestamp>=2){
    //     durationcalcsValid=false
    //   }
    //   else if(timestamp==1 && duration==1){
    //     durationcalcsValid=false
    //   }
    //   if(durationcalcsValid){
    //     this.displayWarning("Two of the three Duration Builder fields must be selected in the Column Mapper.","Duration Calcs Info");
    //   }
    // }
  }
  
  delay(ms: number): Promise<void> {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  // tslint:disable-next-line:typedef
  async scroll(el: HTMLElement) {
    await delay(2000);
    el.scrollIntoView({behavior: 'smooth'});
  }
  onStepChange(event: StepperSelectionEvent): void {
    console.log("Stepper change detected");
  }
  viewIngestTransformConfigJson(): void {
    //this.onViewTransformConfigJson.emit();
    //this.delegate?.viewTransformConfigJson();
    if(this.selectedDataConnectorType.dataConnectorTypeIngest==DataConnectorTypeIngest.DataTypeConverter){
      this.json = JSON.stringify(this.viewModel.DataTypeConverter.toDataTypeConverter(), null, '\t');
    }
    else if(this.selectedDataConnectorType.dataConnectorTypeIngest==DataConnectorTypeIngest.DurationCalc){
      this.json = JSON.stringify(this.viewModel.DurationBuilder.toDurationBuilder(), null, '\t');
    }
    else if(this.selectedDataConnectorType.dataConnectorTypeIngest==DataConnectorTypeIngest.DeduplicateRows){
      this.json = JSON.stringify(this.viewModel.DeduplicateRows.toDeduplicateRows(), null, '\t');
    }
    else if(this.selectedDataConnectorType.dataConnectorTypeIngest==DataConnectorTypeIngest.GeneralParameters){
      this.json = JSON.stringify(this.viewModel.GeneralParameter.toGeneralParameter(), null, '\t');
    }
    else{
      this.json = "";
    }
  }
}
